<script setup>
import { computed } from 'vue'
import { useTranslaterStore } from '@/stores/translater'
import { useLoadYMapScript } from '@/composables/useLoadYMapScript.js'
import UTACarMap from './UTACarMap.vue'

const props = defineProps({
    uuid: {
        type: String,
        required: true
    }
})

// Store
const translaterStore = useTranslaterStore()

// Computed
const getTranslate = computed(() => translaterStore.getTranslate)

const { mapLoader, mapCrash, mapReady } = useLoadYMapScript()
</script>

<template>
    <div class="uta-car-map__crash" v-if="mapCrash">
        {{ getTranslate.CARMAP_CRASH }}
    </div>
    <UTACarMap v-if="mapReady && !mapLoader" :uuid="props.uuid" />
</template>
